import React, { useEffect, useState } from "react";
import landingimage from "../../Assets/landingPage1.png";
import "../../Styles/Auth/Register.css";
import title from "../../Assets/title.jpg";
import fackbookicon from "../../Assets/fackbookicon.svg";
import googleIcon from "../../Assets/googleIcon.svg";
import appleicon from "../../Assets/appleicon.svg";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import axios from "axios";
import { useNavigate } from "react-router-dom";

//images
import titleimage1 from "../../Assets/titleimage1.png";
import titleimage2 from "../../Assets/titleimage2.png";
import titleimage3 from "../../Assets/titleimage3.png";
import titleimage4 from "../../Assets/titleimage4.png";
import titleimage5 from "../../Assets/titleimage5.png";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCH7bVP673lvYtWbXbQzAP3mv2wep6NdO8",
  authDomain: "edifai-forms.firebaseapp.com",
  projectId: "edifai-forms",
  storageBucket: "edifai-forms.firebasestorage.app",
  messagingSenderId: "1026219247928",
  appId: "1:1026219247928:web:55b6e37cec659eb67cd9cd",
  measurementId: "G-85CFES16LD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);


// Third-party providers
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

const Register = () => {
  const [hover, sethover] = useState(false);
  const Navigate = useNavigate();
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [openOtp, setOpenOtp] = useState(false);

  const [otpTimer, setOtpTimer] = useState(60);

  const [otpVerified, setOtpVerified] = useState(false);


  //error states
  const [errors, setErrors] = useState({
    companyName: "",
    email: "",
    phoneNumber: "",
    error: "",
  });

  const handelSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    // Validate each field
    if (!String(companyName || "").trim())
      newErrors.companyName = "Please enter your company name";
    if (!String(email || "").trim())
      newErrors.email = "Please enter a valid email address";
    if (!String(phoneNumber || "").trim())
      newErrors.phoneNumber = "Please enter a valid mobile number";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      console.log("hello world");
      const contactInfo = {
        companyName: companyName,
        email: email,
        phoneNumber: phoneNumber,
        otp,
      };
      try {
        // const response = await axios.post(
        //   `${process.env.REACT_APP_API}/send-otp`,
        //   contactInfo
        // );
        // if (response.data.message === "emailExiting") {
        //   setErrors((pre) => ({ ...pre, email: "Email alredy exist" }));
        // }
        // if (response.data.message === "phoneNumberExiting") {
        //   setErrors((pre) => ({
        //     ...pre,
        //     phoneNumber: "Phone number alredy exist",
        //   }));
        // }
        // if (response.data.message === "success") {
        // console.log(response.data);
        setOpenOtp(true);
        // }
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  useEffect(() => {
    let timerInterval;

    if (openOtp && otpTimer > 0 && !otpVerified) {
      timerInterval = setInterval(() => {
        setOtpTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    };
  }, [openOtp, otpVerified]);

  //social login
  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      console.log("Google User Info:", result.user);
    } catch (error) {
      console.error("Google Login Error:", error.message);
    }
  };

  const handleFacebookLogin = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      console.log("Facebook User Info:", result.user);
    } catch (error) {
      console.error("Facebook Login Error:", error.message);
    }
  };

  // const handleAppleLogin = () => {
  //   alert("Apple login setup is pending.");
  //   // Note
  // };
  const verifyOtp = async (e) => {
    const newErrors = {};
    if (!String(otp || "").trim()) newErrors.otp = "Please enter your otp";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}/verify-otp`,
          { otp: parseInt(otp), phoneNumber, companyName, email }
        );
        if (response.status === 200) {
          if (response.data.message === "otpVerified") {
            setOtpVerified(true);
            console.log("token and user details", response.data.newJser);
            const token = response.data.token;
            localStorage.setItem("token", token);
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("userId", response.data.newUser._id);
            console.log(response.data.user);
            Navigate("/forms/list");
          }
          if (response.data.message === "Invalid OTP") {
            setErrors((pre) => ({
              ...pre,
              otp: "Invalid OTP. Please try again.",
            }));
          }
          if (response.data.message === "otpExpired") {
            setErrors((pre) => ({ ...pre, otp: "OTP expired" }));
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  //resend otp
  const resendOtp = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/send-otp`,
        { phoneNumber, companyName, email }
      );
      if (response.status === 200) {
        setOtpTimer(60);
        console.log(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="registerpage-container">
      <div style={{ flex: 1 }}>
        {/* <img
          src={landingimage}
          alt="LandingImage"
          className="leftside-image-container"
        /> */}
        <Imagecontainer />
      </div>
      {/* <div className="register-form-container"> */}
      {!openOtp ? (
        <div
          style={{
            flex: 1,
            // width: "45%",
            // display: "flex",
            // flexDirection: "column",
            gap: "0.875rem",
            position: 'relative',
          }}
        >
          {/* <div className="register-form-head-container">
              <img
                src={title}
                alt="title"
                style={{ width: "40%", height: "auto" }}
              />
              <h2>Get start free account </h2>
              <p>Welcome back! Please enter your details.</p>
            </div> */}
          <div className="register-form-container">
            <img
              src={title}
              alt="title"
              style={{ width: "20%", height: "auto", }}
            />
            <p style={{ marginTop: '1rem' }}>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatibus, id placeat.</p>
            {/* <p>Welcome back! Please enter your details.</p> */}
            <form onSubmit={handelSubmit}>
              <div className="form-group">
                <label htmlFor="CompanyName">
                  Company name<span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="CompanyName"
                  value={companyName}
                  onChange={(e) => {
                    setErrors((pre) => ({ ...pre, companyName: "" }));
                    setCompanyName(e.target.value);
                  }}
                />
                {errors.companyName && (
                  <span className="register-error-text">
                    {errors.companyName}
                  </span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">
                  Email<span>*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  value={email}
                  onChange={(e) => {
                    setErrors((pre) => ({ ...pre, email: "" }));
                    setEmail(e.target.value);
                  }}
                />
                {errors.email && (
                  <span className="register-error-text">{errors.email}</span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="phoneNumber">
                  Phone number<span>*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="phoneNumber"
                  value={phoneNumber}
                  onChange={(e) => {
                    setErrors((pre) => ({ ...pre, phoneNumber: "" }));
                    setPhoneNumber(e.target.value);
                  }}
                />
                {errors.phoneNumber && (
                  <span className="register-error-text">
                    {errors.phoneNumber}
                  </span>
                )}
              </div>
              {/* <div>
                <div style={{ display: "flex", gap: "0.51rem" }}>
                  <label className="custom-checkbox" style={{ margin: "0" }}>
                    <input
                      type="checkbox"
                      name="option"
                      className="column-filter-input"
                    />
                    <span className="custom-checkbox-mark"></span>
                  </label>
                  <span className="agreeItext">
                    I agree to the <span>Terms of Service</span> and{" "}
                    <span>Privacy Policy</span>.
                  </span>
                </div>
              </div> */}
              <button type="submit" className="register-btn">
                Sign up for free
              </button>
            </form>
            {/* <div className="contine-line-conponent">
              <hr style={{ width: "30%" }} />
              <span>Or continue with</span> <hr style={{ width: "30%" }} />
            </div>
            <div className="other-platform-container">
              <div
                className="otherway-icon-container container1"
                onMouseEnter={() => sethover(1)}
                onMouseLeave={() => sethover("")}
                style={{
                  boxShadow:
                    hover === 1 && "0px 10px 13px 0px rgba(0, 0, 0, 0.13)",
                  cursor: hover === 1 ? "pointer" : "default",
                  border: hover === 1 ? "0px " : "1px solid #dddfdd",
                }}
                onClick={handleGoogleLogin}
              >
                <img src={googleIcon} alt="googleIcon" />
              </div>
              <div
                className="otherway-icon-container container2"
                onMouseEnter={() => sethover(2)}
                onMouseLeave={() => sethover("")}
                style={{
                  boxShadow:
                    hover === 2 && "0px 10px 13px 0px rgba(0, 0, 0, 0.13)",
                  cursor: hover === 2 ? "pointer" : "default",
                  border: hover === 2 ? "0px " : "1px solid #dddfdd",
                }}
                onClick={handleFacebookLogin}
              >
                <img src={fackbookicon} alt="fackbookicon" />
              </div>
              <div
                className="otherway-icon-container container3"
                onMouseEnter={() => sethover(3)}
                onMouseLeave={() => sethover("")}
                style={{
                  boxShadow:
                    hover === 3 && "0px 10px 13px 0px rgba(0, 0, 0, 0.13)",
                  cursor: hover === 3 ? "pointer" : "default",
                  border: hover === 3 ? "0px " : "1px solid #dddfdd",
                }}
              >
                <img src={appleicon} alt="appleicon" />
              </div>
            </div> */}
            <div className="resign-up-text-container" style={{ marginTop: '16px' }}>
              Already have an account{" "}
              <span onClick={() => Navigate("/sign-in")}>Sign In</span>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            flex: 1,
            // width: "45%",
            // display: "flex",
            // flexDirection: "column",
            gap: "0.875rem",
            position: 'relative',
          }}
        >

          <div className="register-form-container">
            <img
              src={title}
              alt="title"
              style={{ width: "20%", height: "auto" }}
            />
            <h2>Get your free account now.</h2>
            <p style={{ marginBottom: '16px' }}>Verify your sign-up</p>
            <p style={{ marginBottom: '16px' }}>Enter the one-time password send to your mobile number </p>
            {/* <div>
              {phoneNumber}{" "}
              <u
                onClick={() => setOpenOtp(false)}
                style={{ cursor: "pointer" }}
              >
                change
              </u>
            </div> */}
            <input
              className="form-control"
              style={{ width: "100%" }}
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => {
                setOtp(e.target.value);
              }}
            />
            {errors.otp && (
              <span className="register-error-text">{errors.otp}</span>
            )}
            {otpTimer > 0 ? (
              <span className="resend-container">Resend {otpTimer}s</span>
            ) : (
              <span
                onClick={resendOtp}
                style={{ color: "blue", cursor: "pointer" }}
              >
                Resend
              </span>
            )}
            {/* <div className="">Resend in {otpTimer}s</div> */}
            <button type="submit" className="register-btn" onClick={(e) => verifyOtp(e)}>
              Sign up for free
            </button>
          </div>
          {/* <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              color: "#8493B2",
              fontSize: "0.875rem",
            }}
          >
            <p>2025, staciacorp corporation all rights reserved.</p>
          </div> */}
        </div>
      )}
    </div>
    // </div>
  );
};

export default Register;

const RegisterComponent = () => {
  return <></>;
};

const OtpVefiy = () => {
  return <></>;
};

export const Imagecontainer = () => {
  const images = [
    {
      src: titleimage1,
      title: "Empowering Your Future Through Technology.",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      src: titleimage2,
      title: "Empowering Your Future Through Technology.",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      src: titleimage3,
      title: "Empowering Your Future Through Technology.",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      src: titleimage4,
      title: "Empowering Your Future Through Technology.",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    }
  ];
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);
  return (
    // <div className="leftside-image-container">
    <div className="image-container">
      <img src={images[activeIndex].src} alt="hello" />
      <div className="register-image-content">
        <h3>{images[activeIndex].title}</h3>
        <p>{images[activeIndex].description}</p>
      </div>
      <div className="dot-container">
        {images.map((_, index) => (
          <div
            key={index}
            className={`dot ${index === activeIndex ? "active" : ""}`}
            style={{
              width: `${index === activeIndex ? "30px" : "15px"}`,
              borderRadius: `${index === activeIndex ? "8px" : "50%"}`,
            }}
          />
        ))}
      </div>
    </div>
    // </div>
  );
};
